import React from 'react';
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {
  render() {
    const { factoryAdjustmentItems, selectedSearchValues } = this.props;

    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate
      .getDate()
      .toString()
      .padStart(2, '0');
    const hours = currentDate
      .getHours()
      .toString()
      .padStart(2, '0');
    const minutes = currentDate
      .getMinutes()
      .toString()
      .padStart(2, '0');

    const cellStyle = {
      borderBottom: 'none',
      borderLeft: '1px solid black',
      fontSize: '14px',
      padding: '1px'
    };

    const invoiceDataList =
      Array.isArray(factoryAdjustmentItems) && factoryAdjustmentItems.length > 0
        ? factoryAdjustmentItems[0]
        : {};

    return (
      <div
        className="record-container"
        style={{
          width: '100%',
          height: '98%',
          position: 'relative'
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex'
          }}
        >
          <div
            className="table-responsive"
            style={{
              width: '48%',
              height: '100%',
              marginLeft: 0,
              border: '1px solid black',
              paddingBottom: '12px',
              paddingLeft: '12px',
              paddingRight: '12px',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div style={{ flex: 1 }}>
              <Box>
                <TableContainer>
                  <Table>
                    <TableBody style={{ padding: 'none' }}>
                      <TableRow style={{ borderBottom: 'none' }}>
                        <TableCell
                          style={{
                            fontSize: '12px',
                            paddingTop: '8px',
                            paddingLeft: '0px',
                            borderBottom: 'none',
                            borderTop: '0px'
                          }}
                        >
                          <p> Office Copy </p>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: '12px',
                            paddingTop: '8px',
                            paddingRight: '0px',
                            borderBottom: 'none',
                            textAlign: 'right'
                          }}
                        >
                          <p>No : {invoiceDataList.invoiceNumber}</p>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box style={{ paddingTop: '20px' }}>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '60px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '18px',
                            border: 'none'
                          }}
                        >
                          <b>Factory Item Gate Pass</b>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '10px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '16px',
                            border: 'none'
                          }}
                        >
                          <b>{selectedSearchValues.groupName}</b>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '10px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '16px',
                            border: 'none'
                          }}
                        >
                          <b>{selectedSearchValues.factoryName}</b>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '10px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '15px',
                            border: 'none'
                          }}
                        >
                          <b> Route - {invoiceDataList.routeName}</b>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              &nbsp;
              <Box style={{ paddingTop: '10px' }}>
                <TableContainer
                  style={{
                    padding: '0px',
                    margin: '0px'
                  }}
                >
                  <Table
                    style={{
                      margin: '0px',
                      padding: '0px'
                    }}
                  >
                    <TableBody>
                      <TableRow
                        style={{
                          padding: '0px',
                          margin: '0px'
                        }}
                      >
                        <TableCell
                          align="left"
                          style={{
                            fontSize: '14px',
                            borderBottom: 'none',
                            padding: '0px',
                            margin: '0px'
                          }}
                        >
                          <b>Customer: </b>
                          {invoiceDataList.fullName +
                            ' - ' +
                            '(' +
                            invoiceDataList.registrationNumber +
                            ')'}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={{
                          padding: '0px',
                          margin: '0px'
                        }}
                      >
                        <TableCell
                          align="left"
                          style={{
                            fontSize: '14px',
                            borderBottom: 'none',
                            padding: '0px',
                            margin: '0px'
                          }}
                        >
                          <b> Issuing Date: </b>{' '}
                          {invoiceDataList.issuingDate.split('T')[0]}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <div>&nbsp;</div>
              <div></div>
              <Box>
                <TableContainer>
                  <Table aria-label="caption table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '1px',
                            fontSize: '14px'
                          }}
                        >
                          Item Supplier
                        </TableCell>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '2px',
                            fontSize: '14px'
                          }}
                        >
                          Item
                        </TableCell>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '1px',
                            fontSize: '14px'
                          }}
                        >
                          QTY
                        </TableCell>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '1px',
                            fontSize: '14px'
                          }}
                        >
                          Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody style={{ borderBottom: '1px solid black' }}>
                      {this.props.factoryAdjustmentItems.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell align={'left'} style={cellStyle}>
                            {item.supplierName}
                          </TableCell>
                          <TableCell align={'left'} style={cellStyle}>
                            {item.itemName}
                          </TableCell>
                          <TableCell align={'center'} style={cellStyle}>
                            {item.approvedQuantity}
                          </TableCell>
                          <TableCell
                            align={'right'}
                            style={{
                              ...cellStyle,
                              borderRight: '1px solid black'
                            }}
                          >
                            {item.totalPrice == null
                              ? ''
                              : Number(item.totalPrice).toLocaleString(
                                  'en-US',
                                  { minimumFractionDigits: 2 }
                                )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              &nbsp;
              <Box>
                <div
                  align={'left'}
                  style={{
                    fontSize: '16px',
                    paddingTop: '10px'
                  }}
                >
                  <p>
                    I do hereby certify that I have received&nbsp;
                    {this.props.factoryAdjustmentItems.map((item, index) => (
                      <span key={index}>
                        <b>{item.approvedQuantity}</b> units of{' '}
                        <b>{item.itemName}</b>
                        {index !== this.props.factoryAdjustmentItems.length - 1
                          ? ', '
                          : ''}
                      </span>
                    ))}
                    &nbsp;from the management of{' '}
                    {selectedSearchValues.factoryName}.
                  </p>
                </div>
              </Box>
            </div>
            <Box>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          fontSize: '14px',
                          border: 'none',
                          textAlign: 'left',
                          paddingBottom: '0px',
                          paddingLeft: '0px'
                        }}
                      >
                        <div>.....................</div>
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: '14px',
                          border: 'none',
                          textAlign: 'right',
                          paddingBottom: '0px',
                          paddingRight: '0px'
                        }}
                      >
                        <div>.................................</div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          fontSize: '14px',
                          border: 'none',
                          textAlign: 'left',
                          padding: '0px'
                        }}
                      >
                        <div>Created By</div>
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: '14px',
                          border: 'none',
                          textAlign: 'right',
                          padding: '0px'
                        }}
                      >
                        <div>Customer Signature</div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          fontSize: '8px',
                          border: 'none',
                          textAlign: 'right',
                          paddingTop: '10px',
                          paddingBottom: '0px',
                          paddingRight: '0px'
                        }}
                      >
                        <div>
                          <p>
                            {year}/{month}/{day} - {hours}:{minutes}
                          </p>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </div>

          <div style={{ marginRight: '4%' }}></div>

          <div
            className="table-responsive"
            style={{
              width: '48%',
              height: '100%',
              marginLeft: 0,
              border: '1px solid black',
              paddingBottom: '12px',
              paddingLeft: '12px',
              paddingRight: '12px',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div style={{ flex: 1 }}>
              <Box>
                <TableContainer>
                  <Table>
                    <TableBody style={{ padding: 'none' }}>
                      <TableRow style={{ borderBottom: 'none' }}>
                        <TableCell
                          style={{
                            fontSize: '12px',
                            paddingTop: '8px',
                            paddingLeft: '0px',
                            borderBottom: 'none',
                            borderTop: '0px'
                          }}
                        >
                          <p>Customer Copy </p>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: '12px',
                            paddingTop: '8px',
                            paddingRight: '0px',
                            borderBottom: 'none',
                            textAlign: 'right'
                          }}
                        >
                          <p>No : {invoiceDataList.invoiceNumber}</p>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box style={{ paddingTop: '20px' }}>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '60px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '18px',
                            border: 'none'
                          }}
                        >
                          <b>Factory Item Gate Pass</b>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '10px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '16px',
                            border: 'none'
                          }}
                        >
                          <b>{selectedSearchValues.groupName}</b>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '10px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '16px',
                            border: 'none'
                          }}
                        >
                          <b>{selectedSearchValues.factoryName}</b>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={{
                          paddingBottom: '10px',
                          paddingTop: '10px'
                        }}
                      >
                        <TableCell
                          style={{
                            textAlign: 'center',
                            padding: '0px',
                            fontSize: '15px',
                            border: 'none'
                          }}
                        >
                          <b> Route - {invoiceDataList.routeName}</b>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              &nbsp;
              <Box style={{ paddingTop: '10px' }}>
                <TableContainer style={{ padding: '0px', margin: '0px' }}>
                  <Table style={{ margin: '0px', padding: '0px' }}>
                    <TableBody>
                      <TableRow style={{ padding: '0px', margin: '0px' }}>
                        <TableCell
                          align="left"
                          style={{
                            fontSize: '14px',
                            borderBottom: 'none',
                            padding: '0px',
                            margin: '0px'
                          }}
                        >
                          <b>Customer: </b>
                          {invoiceDataList.fullName +
                            ' - ' +
                            '(' +
                            invoiceDataList.registrationNumber +
                            ')'}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ padding: '0px', margin: '0px' }}>
                        <TableCell
                          align="left"
                          style={{
                            fontSize: '14px',
                            borderBottom: 'none',
                            padding: '0px',
                            margin: '0px'
                          }}
                        >
                          <b> Issuing Date: </b>{' '}
                          {invoiceDataList.issuingDate.split('T')[0]}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <div>&nbsp;</div>
              <div></div>
              <Box>
                <TableContainer>
                  <Table aria-label="caption table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '1px',
                            fontSize: '14px'
                          }}
                        >
                          Item Supplier
                        </TableCell>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '2px',
                            fontSize: '14px'
                          }}
                        >
                          Item
                        </TableCell>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '1px',
                            fontSize: '14px'
                          }}
                        >
                          QTY
                        </TableCell>
                        <TableCell
                          align={'center'}
                          style={{
                            border: '1px solid black',
                            padding: '1px',
                            fontSize: '14px'
                          }}
                        >
                          Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody style={{ borderBottom: '1px solid black' }}>
                      {this.props.factoryAdjustmentItems.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell align={'left'} style={cellStyle}>
                            {item.supplierName}
                          </TableCell>
                          <TableCell align={'left'} style={cellStyle}>
                            {item.itemName}
                          </TableCell>
                          <TableCell align={'center'} style={cellStyle}>
                            {item.approvedQuantity}
                          </TableCell>
                          <TableCell
                            align={'right'}
                            style={{
                              ...cellStyle,
                              borderRight: '1px solid black'
                            }}
                          >
                            {item.totalPrice == null
                              ? ''
                              : Number(item.totalPrice).toLocaleString(
                                  'en-US',
                                  {
                                    minimumFractionDigits: 2
                                  }
                                )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              &nbsp;
              <Box>
                <div
                  align={'left'}
                  style={{
                    fontSize: '16px',
                    paddingTop: '10px'
                  }}
                >
                  <p>
                    I do hereby certify that I have received&nbsp;
                    {this.props.factoryAdjustmentItems.map((item, index) => (
                      <span key={index}>
                        <b>{item.approvedQuantity}</b> units of{' '}
                        <b>{item.itemName}</b>
                        {index !== this.props.factoryAdjustmentItems.length - 1
                          ? ', '
                          : ''}
                      </span>
                    ))}
                    &nbsp;from the management of{' '}
                    {selectedSearchValues.factoryName}.
                  </p>
                </div>
              </Box>
            </div>
            <div>
              <Box>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{
                            fontSize: '14px',
                            border: 'none',
                            textAlign: 'left',
                            paddingBottom: '0px',
                            paddingLeft: '0px'
                          }}
                        >
                          <div>.....................</div>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: '14px',
                            border: 'none',
                            textAlign: 'right',
                            paddingBottom: '0px',
                            paddingRight: '0px'
                          }}
                        >
                          <div>.................................</div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{
                            fontSize: '14px',
                            border: 'none',
                            textAlign: 'left',
                            padding: '0px'
                          }}
                        >
                          <div>Created By</div>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: '14px',
                            border: 'none',
                            textAlign: 'right',
                            padding: '0px'
                          }}
                        >
                          <div>Customer Signature</div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{
                            fontSize: '8px',
                            border: 'none',
                            textAlign: 'right',
                            paddingTop: '10px',
                            paddingBottom: '0px',
                            paddingRight: '0px'
                          }}
                        >
                          <div>
                            <p>
                              {year}/{month}/{day} - {hours}:{minutes}
                            </p>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
